'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ENGAGEMENT_ELEMENTS = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _timeout = require('./timeout');

var _timeout2 = _interopRequireDefault(_timeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    link: 'ExternalLink#link'
}; /* globals window */


var ExternalLink = function ExternalLink(_ref) {
    var href = _ref.href,
        children = _ref.children,
        target = _ref.target,
        onClick = _ref.onClick,
        attributes = _ref.attributes,
        engagement = _ref.engagement,
        engagementTimeout = _ref.engagementTimeout,
        theme = _ref.theme,
        testTagDefault = _ref.testTagDefault;

    var decodedURI = void 0;

    try {
        decodedURI = decodeURI(href);
    } catch (err) {
        return null;
    }

    return _react2.default.createElement(
        'a',
        (0, _extends3.default)({}, attributes({ elementIdentifier: ENGAGEMENT_ELEMENTS.link, meta: { href: href } }), {
            href: decodedURI,
            target: target,
            rel: 'noopener',
            className: theme.root,
            'data-test-tag': testTagDefault,
            onClick: function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
                    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        rest[_key - 1] = arguments[_key];
                    }

                    var doEngagement;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    event.preventDefault();

                                    if (onClick) {
                                        onClick.apply(undefined, [event].concat(rest));
                                    }

                                    _context.prev = 2;
                                    doEngagement = _promise2.default.resolve(engagement({
                                        elementIdentifier: ENGAGEMENT_ELEMENTS.link,
                                        meta: { event: event }
                                    }));
                                    _context.next = 6;
                                    return (0, _timeout2.default)(doEngagement, engagementTimeout);

                                case 6:
                                    _context.next = 10;
                                    break;

                                case 8:
                                    _context.prev = 8;
                                    _context.t0 = _context['catch'](2);

                                case 10:
                                    _context.prev = 10;

                                    window.location.assign(href);
                                    return _context.finish(10);

                                case 13:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, undefined, [[2, 8, 10, 13]]);
                }));

                return function (_x) {
                    return _ref2.apply(this, arguments);
                };
            }()
        }),
        children
    );
};

ExternalLink.propTypes = {
    attributes: _propTypes2.default.func,
    engagement: _propTypes2.default.func,
    engagementTimeout: _propTypes2.default.number,
    href: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node.isRequired,
    target: _propTypes2.default.oneOf(['_blank', '_self', '_parent', '_top']),
    onClick: _propTypes2.default.func,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string
    }),
    testTagDefault: _propTypes2.default.string
};

ExternalLink.defaultProps = {
    attributes: function attributes() {
        return {};
    },
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    engagementTimeout: 400,
    target: undefined,
    onClick: undefined,
    theme: {},
    testTagDefault: '@spp/ui-external-link'
};

exports.default = ExternalLink;
//# sourceMappingURL=ExternalLink.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-external-link/lib/cjs/ExternalLink.js
 ** module id = 646
 ** module chunks = 1
 **/